import React, { useContext, useEffect } from 'react';
import c from 'classnames';
import throttle from 'lodash/throttle';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import { PopupContext } from '../../popups/PopupContext';
import s from './ModalLayout.scss';
/**
 * A modal layout with slots for a `header`, `content`, and `footer`.
 *
 * Note: If you need the slots separated by borders, consider using `<SegmentedModalLayout />`. They're separated for now
 * for safety down the road. There are too many possible modal designs to put all of these style options into one component.
 */ const ModalLayout = ({ isFullscreen, header, headerBorder, preamble, content, footer, footerBorder, className, contentClassName, footerClassName, innerScrollRef, withScrollableContentWrapper = true })=>{
    useEffect(()=>{
        const updateVhUnitVar = ()=>{
            const vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        };
        const updateVhUnitVarThrottled = throttle(updateVhUnitVar, 250);
        updateVhUnitVar();
        window.addEventListener('resize', updateVhUnitVarThrottled);
        return ()=>window.removeEventListener('resize', updateVhUnitVarThrottled);
    }, []);
    const { setDefaultScrollableRef } = useContext(PopupContext);
    return /*#__PURE__*/ React.createElement(Section, {
        className: c(s['root'], isFullscreen && s['fullscreen'], className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: c(s['header-and-preamble'], headerBorder && s['header-and-preamble-border'])
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['header']
    }, header), /** We expect the consumer to handle the layouting here */ preamble), /*#__PURE__*/ React.createElement("div", {
        className: c(s['content'], withScrollableContentWrapper && s['scrollable'], contentClassName),
        ref: (node)=>{
            if (withScrollableContentWrapper) {
                innerScrollRef && innerScrollRef(node);
                // Set the default scrollable, see ModalWrapper for the logic
                setDefaultScrollableRef && setDefaultScrollableRef(node);
            }
        }
    }, content), footer && /*#__PURE__*/ React.createElement("div", {
        className: c(footerClassName, s['footer'], footerBorder && s['footer-border'])
    }, footer));
};
ModalLayout.displayName = 'ModalLayout';
export default ModalLayout;
